/* NAD Hair — Trust + Science (Combined)
   - Initializes BOTH carousels inside the combined section
   - Trusted arrows: [data-nhts-tr-prev], [data-nhts-tr-next]
   - Science arrows: [data-nhts-si-prev], [data-nhts-si-next]
*/

(function () {
  function initTrusted(root) {
    const trusted = root.querySelector("[data-nhts-trusted]");
    if (!trusted) return;

    const track = trusted.querySelector(".nhtr__track");
    if (!track) return;

    const btnPrev = trusted.querySelector("[data-nhts-tr-prev]");
    const btnNext = trusted.querySelector("[data-nhts-tr-next]");
    if (!btnPrev || !btnNext) return;

    function getStep() {
      const slide = track.querySelector(".nhtr__slide");
      if (!slide) return Math.max(320, track.clientWidth * 0.9);

      const rect = slide.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;

      return rect.width + gap;
    }

    function updateButtons() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
      const x = track.scrollLeft;

      btnPrev.disabled = x <= 2;
      btnNext.disabled = x >= maxScrollLeft;
    }

    btnPrev.addEventListener("click", function () {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    btnNext.addEventListener("click", function () {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(updateButtons);
    });

    window.addEventListener("resize", function () {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
  }

  function initScience(root) {
    const science = root.querySelector("[data-nhts-science]");
    if (!science) return;

    const track = science.querySelector(".nhsi__track");
    if (!track) return;

    const btnPrev = science.querySelector("[data-nhts-si-prev]");
    const btnNext = science.querySelector("[data-nhts-si-next]");

    if (!btnPrev || !btnNext) return;

    function getStep() {
      const slide = track.querySelector(".nhsi__slide");
      if (!slide) return Math.max(320, track.clientWidth * 0.9);

      const rect = slide.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;

      return rect.width + gap;
    }

    function updateButtons() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
      const x = track.scrollLeft;

      btnPrev.disabled = x <= 2;
      btnNext.disabled = x >= maxScrollLeft;
    }

    btnPrev.addEventListener("click", function () {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    btnNext.addEventListener("click", function () {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(updateButtons);
    });

    window.addEventListener("resize", function () {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
  }

  function initAll() {
    document.querySelectorAll("[data-nhts]").forEach(function (root) {
      initTrusted(root);
      initScience(root);
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);
})();
